module.exports = __webpack_public_path__ + "img/l-hd.3f5a0aa9.jpg";